import { Component, OnInit } from '@angular/core';
import {AdditionalLogo, AssetsService} from '../../../shared/services/assets.service';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';
import {FiltersService} from '../../../shared/services/filters.service';
import {StepConfig} from '../../configuration/step-config';
import {WizardService} from '../../services/wizard.service';
import {ConfigurationService} from '../../services/impl/configuration/configuration.service';
import {isMPay, isSkycash} from '../../utils/utils';
import {OfferNumberContext, OfferNumberService} from '../../../shared/services/offer-number.service';
import {SendCalculationEmailService} from '../../services/impl/send-calculation-email.service';
import {ApplicationContextService} from '../../services/impl/configuration/application-context.service';

/* Moto 2.0 header */

@Component({
  selector: 'app-narrow-header',
  templateUrl: './narrow-header.component.html',
  styleUrls: []
})
export class NarrowHeaderComponent implements OnInit {

  readonly offerNumberContext = OfferNumberContext.HEADER;

  get additionalLogo(): AdditionalLogo {
    return this.assetsService.getAdditionalLogo();
  }

  get headerConfig() {
    return this.configurationService.uiConfig.headerConfig;
  }

  get logo() {
    return this.headerConfig.logo;
  }

  get title() {
    return this.headerConfig.title;
  }

  get currentStep(): StepConfig {
    return this.wizardService.currentStep;
  }

  get wideMainContainer(): boolean {
    return this.filtersService.filtersVisible && isNotNullOrUndefined(this.currentStep) && this.currentStep.isOfferStep && this.filtersService.filtersExpanded;
  }

  get additionalLogoKioskPolisLogoAnchor(): boolean {
    return !(isMPay || isSkycash);
  }

  get KioskPolisWebsiteUrl(): string {
    return 'https://kioskpolis.pl/';
  }

  get readonly(): boolean {
    return this.wizardService.readonly;
  }

  get helplineWidgetVisible(): boolean {
    return false;
  }

  get showOfferNumber(): boolean {
    return this.wizardService.resolveElementVisibility(this.headerConfig.offerNumber) && isNotNullOrUndefined(this.offerNumberService.offerNumberForHeader);
  }

  get logoRedirectEnabled(): boolean {
    return !(isSkycash() || isMPay()) && !this.contextService.headerLogoRedirectDisabled && !this.wizardService.headerLogoRedirectDisabled;
  }

  get additionalLogoRedirectEnabled(): boolean {
    return !this.contextService.headerLogoRedirectDisabled && !this.wizardService.headerLogoRedirectDisabled;
  }

  constructor(private assetsService: AssetsService,
              private configurationService: ConfigurationService,
              private offerNumberService: OfferNumberService,
              private contextService: ApplicationContextService,
              public sendCalculationEmailService: SendCalculationEmailService,
              public wizardService: WizardService,
              private filtersService: FiltersService) { }

  ngOnInit() {
  }

  navigateToLP() {
    if (this.logoRedirectEnabled) {
      window.open('https://kioskpolis.pl/', '_blank');
    }
  }

}
